/**
 * flight — part of the German catalogue (the reference language).
 * Merged in `i18n/de.ts`; every key here must exist in `i18n/en/flight.ts`.
 */

export const flight = {
  /* ---------------- editor ---------------- */
  'ed.status.local': 'nur in diesem Browser',
  'ed.status.dirty': 'ungespeicherte Änderungen',
  'ed.status.saving': 'speichert …',
  'ed.status.saved': 'gespeichert',
  'ed.status.error': 'Speichern fehlgeschlagen',
  'ed.status.conflict': 'Konflikt',
  'ed.autocalc': 'Werte automatisch rechnen',
  'ed.export': 'Plan als Datei',
  'ed.import': 'Plan aus Datei',
  'ed.clear': 'Leeren',
  'ed.share': 'Teilen',
  'ed.more': 'Mehr',
  'ed.title.ph': 'Titel des Plans',
  'ed.pdf.busy': 'Erzeuge PDF …',
  'ed.pdf': 'PDF herunterladen',
  'ed.conflict.text': 'Dieser Plan wurde anderswo geändert. Ihre Fassung ist noch hier und wurde nicht überschrieben.',
  'ed.conflict.take': 'Serverstand übernehmen',
  'ed.conflict.keep': 'Meine Fassung behalten',
  'ed.saveerr': 'Speichern auf dem Server fehlgeschlagen: {error} · Die lokale Kopie ist aktuell.',
  'ed.retry': 'Erneut versuchen',
  'ed.sharelink': 'Freigabe-Link: {url}',
  'ed.copy': 'Kopieren',
  'ed.close': 'Schließen',
  'ed.confirm.import': 'Aktuelle Eingaben durch den Inhalt der Datei ersetzen?',
  'ed.confirm.clear': 'Alle Eingaben löschen?',
  'ed.notavailable': 'Plan nicht verfügbar',
  'ed.toplans': 'Zur Planliste',

  /* ---------------- the workspace ---------------- */
  'insp.tabs': 'Ansicht',
  'insp.route': 'Strecke',
  'insp.navlog': 'NavLog',
  'insp.weather': 'Wetter',
  'insp.terrain': 'Gelände',
  'insp.form': 'Formular',
  'insp.export': 'Export',
  'insp.collapse': 'Bereich einklappen',
  'insp.expand': 'Bereich ausklappen',
  'summary.aria': 'Flug in Zahlen',
  'summary.eta': 'ETA',
  'summary.fuel': 'Kraftstoff',
  'summary.sh': 'SH max',
  'flight.back': 'Zurück zu den Flügen',
  'flight.tab.map': 'Karte',
} as const;
